import { render, staticRenderFns } from "./ParentMembershipList.vue?vue&type=template&id=70316158"
import script from "./ParentMembershipList.vue?vue&type=script&lang=js"
export * from "./ParentMembershipList.vue?vue&type=script&lang=js"
import style0 from "./ParentMembershipList.vue?vue&type=style&index=0&id=70316158&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports